<template>
  <a-modal
      class="team-target-page"
      centered
      :title="`消耗目标 (${model.name})`"
      :width="'55%'"
      :mask-closable="false"
      :visible="showTeamTargetPage"
      :confirmLoading="loading"
      :bodyStyle="{ padding: 0 }"
      :footer="null"
      @cancel="close"
  >
    <a-layout id="layout">
      <div class="search-wrapper">
        <a-space>
          <a-month-picker v-model="queryParam.month"  valueFormat="YYYY-MM" placeholder="请选择月份查询"/>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button type="primary" @click="resetSearch">重置</a-button>

          <a-button @click="addTarget" icon="plus" v-if="accessTo('store')">新增消耗目标</a-button>
        </a-space>
      </div>

      <a-layout-content id="layout-content">
        <a-table
            size="small"
            :columns="columns"
            :row-key="record => record.id"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            :transform-cell-text="$helper.emptyFormat"
            @change="handleTableChange"
        >
        <div slot="month_progress" slot-scope="month_progress" class="custom-progress">
          <span v-if="month_progress !== null">
            <a-progress  :percent="month_progress" strokeColor="#E3724E" :showInfo="false"  status="active" style="padding-right:60px;"/>
            <span style="margin-left:-60px">  {{ month_progress }}% </span>
          </span>
          <span v-else>未填写月目标</span>
        </div>

          <div slot="action" slot-scope="record" class="actions">
            <template v-if="accessTo(['update', 'destroy'])">
              <a href="javascript:;" @click="addTarget(record)" v-if="accessTo('update')">编辑</a>
              <a-divider type="vertical"/>
              <a-popconfirm title="确认要删除吗?" @confirm="destroy(record)" v-if="accessTo('destroy')">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template v-else>-</template>
          </div>

        </a-table>
      </a-layout-content>
    </a-layout>

    <create-form
      v-if="showForm"
      :showForm.sync="showForm"
      :targetModel="targetModel"
      @success="refresh"
    />

  </a-modal>

</template>

<style lang="less" scoped>
@import 'TeamTarget';
</style>

<script>
import TeamTarget from './TeamTarget'

export default TeamTarget
</script>

